var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
        content: _vm.tooltip,
        placement: 'bottom',
        defaultHideOnTargetClick: false,
        autoHide: false,
    }),expression:"{\n        content: tooltip,\n        placement: 'bottom',\n        defaultHideOnTargetClick: false,\n        autoHide: false,\n    }"}],staticClass:"v-button-report"},[_vm._t("default",function(){return [_c('ReportSVG')]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }